module.exports = __webpack_public_path__ + "static/img/200.d544896.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/csfish/200.png
// module id = viA6
// module chunks = 0